const aaa = [
	{
		path: "shopPurchase",
		component: () => import("@/views/caigou/shopPurchase/shopPurchase.vue"),
		meta:{title:'门店采购',keepAlive:false},
	},
	{
		path: "shopPurchaseEdit",
		component: () => import("@/views/caigou/shopPurchase/shopPurchaseEdit.vue"),
		meta:{title:'采购编辑'},
	},
	{
		path: "inspectionEdit",
		component: () => import("@/views/caigou/shopPurchase/inspectionEdit.vue"),
		meta:{title:'验货编辑'},
	},
	{
		path: "wuliaoList",
		component: () => import("@/views/caigou/wuliao/mendian/list.vue"),
		meta:{title:'物料列表'},
	},
	{
		path: "updateWuliao",
		component: () => import("@/views/caigou/wuliao/mendian/updateWuliao.vue"),
		meta:{title:'更新物料'},
	},
]
export default aaa;